import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	AccommodationState,
	_STATE_ACCOMMODATIONS_FEATURE_KEY,
} from './accommodation.reducer';

export const getAccommodationState = createFeatureSelector<AccommodationState>(
	_STATE_ACCOMMODATIONS_FEATURE_KEY,
);

export const getStateAccommodationsLoaded = createSelector(
	getAccommodationState,
	(state: AccommodationState) => state.loaded,
);

export const getStateAccommodationsError = createSelector(
	getAccommodationState,
	(state: AccommodationState) => state.error,
);

export const getStateAccommodations = createSelector(
	getAccommodationState,
	(state: AccommodationState) => state.accommodation,
);

export const getStateAccommodationUniversityUrl = createSelector(
	getAccommodationState,
	(state: AccommodationState) => state.selectedUniversityUrl,
);
